module.exports = __webpack_public_path__ + "static/media/IMG_20180723_122821_180.69ae5482.jpg";